import type {ReactElement} from 'react';
import React from 'react';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import {useGetKeyFromLineItem} from '@Hooks/poster-editor/useGetKeyFromLineItem';

export function LineRoundedCornersOption(): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemIsRoundedState = useGetKeyFromLineItem('isRounded');

  if (!activeItem || activeItemIsRoundedState === undefined) {
    throw new Error(`Item doesn't have thickness property`);
  }

  const pageHashedId = window.posterEditor?.whiteboard?.getCurrentPageId();
  if (!pageHashedId) {
    return null;
  }
  const page = window.posterEditor?.whiteboard?.pages.getPage(pageHashedId);
  if (!page) {
    return null;
  }

  const isToggled = (): boolean => {
    return activeItemIsRoundedState;
  };

  const onToggleHandler = (undoable = true): void => {
    page.setActiveItemControlsHideState({activeItemHashId: activeItemId, shouldHideControls: true});
    void activeItem.updateFromObject(
      {
        isRounded: !activeItemIsRoundedState,
      },
      {
        undoable,
      }
    );
    setTimeout(() => {
      page.setActiveItemControlsHideState({activeItemHashId: activeItemId, shouldHideControls: false});
    }, 1000);
  };

  return <ContextualMenuToggleOption id="line-rounded-corners-option-toggle" label={window.i18next.t('pmwjs_rounded_corners')} isChecked={isToggled()} onClick={onToggleHandler} />;
}
